/**
 * Utility functions for URL parameter handling
 */

/**
 * Get the organization token from the URL path
 * Extracts the last segment of the path (e.g., 'pc' from 'https://chat.prodagen.com/pc')
 * @returns The organization token if present, null otherwise
 */
export const getOrgTokenFromPath = (): string | null => {
  const path = window.location.pathname;
  const segments = path.split('/').filter(segment => segment.length > 0);
  
  // Handle chat routes - don't treat these route names as org tokens
  const reservedRouteNames = new Set(['anon-chat', 'auth-chat']);
  if (segments.length === 1 && reservedRouteNames.has(segments[0])) {
    return null; // Let it fall back to localStorage organization
  }
  
  // For routes like '/pc/anon-chat' or '/pc/auth-chat', return 'pc' as the org token
  if (segments.length === 2 && reservedRouteNames.has(segments[1])) {
    return segments[0];
  }
  
  // Return the last segment if it exists and is not empty
  return segments.length > 0 ? segments[segments.length - 1] : null;
};

/**
 * Get the organization parameter from the current URL (legacy support)
 * @returns The organization ID if present, null otherwise
 */
export const getOrgFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('org');
};

/**
 * Get any query parameter from the current URL
 * @param paramName The name of the parameter to retrieve
 * @returns The parameter value if present, null otherwise
 */
export const getUrlParameter = (paramName: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};
